import FadeIn from "../../../components/animation/fadeIn";
import Category from "../../../components/category/category";

import { diet } from "../../../constants/diet";

export default function Diet() {
    return (
        <section id="Diet">
            <Category>Diet</Category>
            {diet.map((val, i) => (
                <p key={ i } className="article-information">{val}</p>
            ))}
            <FadeIn animateFrom={{ x: '300', opacity: '0' }} animateTo={{ x: '0', opacity: '1' }} onView={ true } rootMargin='10px' threshold={ 0.1 } delay={ 100 } transitionDuration={ 800 }>
                <blockquote>"In the chase between cheetah and deer, most of the times deer wins. The cheetah runs for food; while the deer for life. Purpose is more important than need..." &mdash; My brain</blockquote>
            </FadeIn>
            
        </section>
    );
};